// extracted by mini-css-extract-plugin
module.exports = {"container":"StatsList_container__1Biyn"};